import styled from 'styled-components';
import { gte } from '@lendi-ui/breakpoint';
import getColour from '@lendi-ui/commons/colours';
import { mb, mr, p, px, py } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';

import { materialCard } from '@funnels/ui-components';

export const Container = styled.div`
  text-align: center;
  border-radius: ${select('borderRadius')};
  border: solid 1px ${() => getColour('border', 'container')};
  background-color: ${() => getColour('background', 'container')};
  ${px({ mobile: 'xxs', tablet: 'xs', desktop: 'sm' })}
  ${py({ mobile: 'xxs', tablet: 'xs', desktop: 'md' })}
  ${mb('sm')}

  ${gte('sm')`
    text-align: left;
  `}
`;

export const Content = styled.div<{ width: number }>`
  ${materialCard}
  box-sizing: border-box;
  display: inline-block;
  ${p('xxxs')}
  > * {
    ${mr('nil')}
  }

  ${gte('sm')`
    > * {
      ${mr('xxs')}
    }
  `}
`;
